<span [mdePopoverTriggerFor]="sortPopover" class="sort-column" mdePopoverTriggerOn="click"
  [ngClass]="{ 'active-column-sort': isActive('asc') || isActive('desc') }">
  {{ columnName }}
  @if (isActive('asc')) {
    <mat-icon [inline]="true">keyboard_arrow_up</mat-icon>
  }
  @if (isActive('desc')) {
    <mat-icon [inline]="true">keyboard_arrow_down</mat-icon>
  }
</span>

<mde-popover #sortPopover="mdePopover" [mdePopoverCloseOnClick]="false" [mdePopoverOverlapTrigger]="false">
  <mat-card appearance="outlined">
    <div class="sorting-grid">
      <div (keydown)="triggerClose($event)">
        <ng-content></ng-content>
      </div>
      @if (sortingList.length) {
        <div class="list">
          @for (sorting of sortingList; track sorting) {
            <div class="item">
              {{ sorting.label }}
              <div style="margin-left: 10px">
                @for (i of [['asc', 'keyboard_arrow_up'], ['desc', 'keyboard_arrow_down']]; track i) {
                  <mat-icon (click)="changeSort(sorting.field, i[0])" [color]="getColor(sorting.field, i[0])"
                    class="sort-arrow">
                    {{ i[1] }}
                  </mat-icon>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </mat-card>
</mde-popover>
